import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bold white" }
const _hoisted_2 = { class: "regular white" }
const _hoisted_3 = { class: "mainpage__booking-cashback flex middle-xs" }
const _hoisted_4 = { class: "white bold fs-general" }
const _hoisted_5 = {
  key: 0,
  class: "p-home--whitelabel__powered fs-small regular"
}

import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useMeta } from 'vue-meta';
  import { lazyComponent } from '@/router/routes';
  import { User } from 'types';
  import { CashbackCheckIcon32 } from '@/views/icons';
  import HomeHeaderWrapperComponent from '@/views/components/HomePages/HomeHeaderWrapperComponent.vue';
  import HotelsSearchCriteriaComponent from '@/views/components/HotelsSearchCriteriaComponent.vue';
  import '@/assets/css/home-p-search-form.css';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

  const GeniusModalComponent = lazyComponent('GeniusModalComponent');
  const HomeContent = lazyComponent('HomePages/HomeContent');

  const store = useStore();
  const { t, tm } = useI18n();
  useMeta({
    title: `${t('mainpage.title')} - FinalPrice`,
  });

  const isWhitelabel = computed<boolean>(
    () => store.getters['support/isWhiteLable'],
  );
  const userV2 = computed<User.UserV2>(() => store.state.user.userV2);
  const userCategory = computed<User.UserCategory.Category>(
    () => store.state.user.category,
  );

  const isBookingCashbackModalOpen = ref<boolean>(false);

  const bookingAffilateLink = computed(() => {
    const params = process.env.BOOKING_AFFILATE;
    if (params) {
      return `${params['url']}?aid=${params['aid']}&label=${userV2.value?.userId}`;
    }
    return '';
  });

  function onSupplierLinkClick() {
    isBookingCashbackModalOpen.value = false;
  }

  function resetSearchSupportingData() {
    store.commit('searchCriteria/setId', { id: '' });
    store.commit('search/saveSearchState', { route: null, position: 0 });
  }

  function setContainerHeight() {
    if (!isWhitelabel.value) {
      return;
    }

    const container = document.querySelector(
      '.b-home-header',
    ) as HTMLDivElement;
    if (container) {
      container.style.height = window.innerHeight + 'px';
    }
  }

  onMounted(() => {
    store.dispatch('support/stopCountdown');
    resetSearchSupportingData();

    setContainerHeight();
    window.addEventListener('resize', setContainerHeight);
    window.addEventListener('orientationchange', setContainerHeight);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', setContainerHeight);
    window.removeEventListener('orientationchange', setContainerHeight);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mainpage p-home p-product-home", { 'p-home--whitelabel': _unref(isWhitelabel) }])
  }, [
    _createVNode(HomeHeaderWrapperComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('mainpage.title')), 1),
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('mainpage.subtitle')), 1),
        _createVNode(HotelsSearchCriteriaComponent, {
          class: "b-home-form",
          traveleresFieldClassName: "p-home__travelers-field"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(CashbackCheckIcon32)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(userCategory) === _unref(User).UserCategory.Category.Individual
              ? _unref(t)('mainpage.bookingCashback.descriptionForNonBusiness')
              : _unref(t)('mainpage.bookingCashback.description')), 1)
        ])
      ]),
      _: 1
    }),
    (_unref(isWhitelabel))
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)('poweredByFp')), 1))
      : (_openBlock(), _createBlock(_unref(HomeContent), { key: 1 })),
    (_unref(userV2))
      ? (_openBlock(), _createBlock(_unref(GeniusModalComponent), {
          key: 2,
          isShown: isBookingCashbackModalOpen.value,
          title: _unref(t)('mainpage.bookingCashback.modal.title'),
          content: (_unref(tm)('mainpage.bookingCashback.modal.content') as any),
          link: _unref(bookingAffilateLink),
          btnText: _unref(t)('mainpage.bookingCashback.modal.btn'),
          onOnClose: _cache[0] || (_cache[0] = ($event: any) => (isBookingCashbackModalOpen.value = false)),
          onOnSupplierLinkClick: onSupplierLinkClick
        }, null, 8, ["isShown", "title", "content", "link", "btnText"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})